import { schema } from 'normalizr';
import mapKeysToCamelCase from '@/utils/map-keys-to-camel-case';
import accountSchema from './accountSchema';
import thirdPartyServiceSchema from './thirdPartyServiceSchema';

const accOrderSchema = new schema.Entity(
  'accOrders',
  {
    account: accountSchema,
  },
  {
    processStrategy: (entity) => mapKeysToCamelCase(entity, true),
  }
);

const thirdPartyServiceDocumentSchema = new schema.Entity(
  'thirdPartyServiceDocuments',
  {
    account: accountSchema,
    thirdPartyService: thirdPartyServiceSchema,
    accOrder: accOrderSchema,
  },
  {
    processStrategy: (entity) => mapKeysToCamelCase(entity, true),
  }
);

export default thirdPartyServiceDocumentSchema;
